import { Alert, AlertTitle } from '@mui/material';

export default function AlertValid() {
  return (
    <Alert severity="success">
      <AlertTitle>Valid</AlertTitle>
      Selected files are valid.
    </Alert>
  );
}
